import React, { FC }                                           from 'react';
import { CORVAL_PRODUCT_NAME }                                 from '../../../constants/SystemEnums';
import { FinePrintMessage }                                    from '../util/messaging/FinePrintMessage';
import { CorvalVersionNumber }                                 from './CorvalVersionNumber';
import { CorvalExternalLink, CorvalPreparedExternalLinkProps } from './CorvalExternalLink';

const CorvalPrivacyPolicyLink: FC<Omit<CorvalPreparedExternalLinkProps, 'content'>> = ( props ) => {
	
	return (
		<CorvalExternalLink
			openAsTab={ true }
			url={ 'https://corval.io/privacy-policy/' }
			content={ 'Privacy Policy' }
			popupContent={ <FinePrintMessage>Links to the privacy policy for { CORVAL_PRODUCT_NAME } <CorvalVersionNumber/></FinePrintMessage> }
			popupProps={ { flowing: true } }
			{ ...props }
		/>
	);
};

export { CorvalPrivacyPolicyLink }
